import React, { useState } from "react";
import { DocWrapper, ExpandableCard } from "./DocStyles";

export default function Architecture() {
  const [openCards, setOpenCards] = useState({ 0: true, 1: true, 2: true });

  const toggleCard = (index) => {
    setOpenCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <DocWrapper>
      <div className="header">
        <h1>B4T System Architecture</h1>
        <div className="tagline">Buddy4Travel — Distributed Travel Assistance Marketplace</div>
        <div className="subtitle">Core Architecture · Communication Patterns · Technology Stack</div>
      </div>

      <div className="card" style={{ padding: "12px" }}>
        <svg viewBox="0 0 1000 860" xmlns="http://www.w3.org/2000/svg" style={{ background: "#ffffff" }}>
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#f0f0f0" strokeWidth="0.5"/>
            </pattern>
            <marker id="arrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
              <path d="M 0 0 L 10 5 L 0 10 Z" fill="#6b7280"/>
            </marker>
            <marker id="arrow-emerald" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
              <path d="M 0 0 L 10 5 L 0 10 Z" fill="#059669"/>
            </marker>
            <marker id="arrow-cyan" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
              <path d="M 0 0 L 10 5 L 0 10 Z" fill="#004d2c"/>
            </marker>
            <marker id="arrow-violet" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
              <path d="M 0 0 L 10 5 L 0 10 Z" fill="#a78bfa"/>
            </marker>
            <marker id="arrow-dashed" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto">
              <path d="M 0 0 L 10 5 L 0 10 Z" fill="#f43f5e"/>
            </marker>
          </defs>

          <rect width="1000" height="860" fill="#fafafa"/>

          <rect x="20" y="10" width="480" height="840" rx="12" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="8,4" opacity="0.5"/>
          <text x="260" y="36" textAnchor="middle" fill="#f59e0b" fontSize="10" opacity="0.7">Consumer Ecosystem (b4t/consumer/)</text>

          <rect x="510" y="10" width="470" height="840" rx="12" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="8,4" opacity="0.5"/>
          <text x="745" y="36" textAnchor="middle" fill="#f59e0b" fontSize="10" opacity="0.7">Business / Agent Ecosystem (b4t/business/)</text>

          <rect x="40" y="55" width="200" height="70" rx="6" fill="#ffffff"/>
          <rect x="40" y="55" width="200" height="70" rx="6" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1.5"/>
          <text x="140" y="85" textAnchor="middle" fill="#004d2c" fontSize="12" fontWeight="bold">Consumer Mobile App</text>
          <text x="140" y="102" textAnchor="middle" fill="#6b7280" fontSize="9">React Native / iOS + Android</text>
          <text x="140" y="115" textAnchor="middle" fill="#6b7280" fontSize="9">Care Seekers</text>

          <rect x="280" y="55" width="200" height="70" rx="6" fill="#ffffff"/>
          <rect x="280" y="55" width="200" height="70" rx="6" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1.5"/>
          <text x="380" y="85" textAnchor="middle" fill="#004d2c" fontSize="12" fontWeight="bold">Public Website</text>
          <text x="380" y="102" textAnchor="middle" fill="#6b7280" fontSize="9">Laravel / Vue.js</text>
          <text x="380" y="115" textAnchor="middle" fill="#6b7280" fontSize="9">b4t.com (Lead Gen + Proxy)</text>

          <path d="M 140 125 L 140 180 L 380 180 L 380 210" fill="none" stroke="#004d2c" strokeWidth="1.5" markerEnd="url(#arrow-cyan)"/>
          <path d="M 380 125 L 380 210" fill="none" stroke="#004d2c" strokeWidth="1.5" markerEnd="url(#arrow-cyan)"/>

          <rect x="260" y="210" width="240" height="85" rx="6" fill="#ffffff"/>
          <rect x="260" y="210" width="240" height="85" rx="6" fill="rgba(0,77,44,0.06)" stroke="#059669" strokeWidth="1.5"/>
          <text x="380" y="240" textAnchor="middle" fill="#059669" fontSize="12" fontWeight="bold">Consumer API (Node.js)</text>
          <text x="380" y="257" textAnchor="middle" fill="#6b7280" fontSize="9">Express + MongoDB (api.b4t.com)</text>
          <text x="380" y="272" textAnchor="middle" fill="#6b7280" fontSize="9">Auth · Matchboard · Bookings · Payments</text>
          <text x="380" y="287" textAnchor="middle" fill="#6b7280" fontSize="9">Verification · Notifications</text>

          <path d="M 380 295 L 380 335" fill="none" stroke="#a78bfa" strokeWidth="1.5" markerEnd="url(#arrow-violet)"/>

          <rect x="330" y="335" width="130" height="55" rx="6" fill="#ffffff"/>
          <rect x="330" y="335" width="130" height="55" rx="6" fill="rgba(76, 29, 149, 0.06)" stroke="#a78bfa" strokeWidth="1.5"/>
          <text x="395" y="358" textAnchor="middle" fill="#a78bfa" fontSize="11" fontWeight="bold">MongoDB</text>
          <text x="395" y="375" textAnchor="middle" fill="#6b7280" fontSize="9">Bookings · Users ·</text>
          <text x="395" y="385" textAnchor="middle" fill="#6b7280" fontSize="9">Transactions</text>

          <path d="M 380 295 L 380 410" fill="none" stroke="#a78bfa" strokeWidth="1.5" strokeDasharray="4,3" markerEnd="url(#arrow-violet)"/>

          <rect x="180" y="410" width="400" height="55" rx="6" fill="#ffffff"/>
          <rect x="180" y="410" width="400" height="55" rx="6" fill="rgba(76, 29, 149, 0.06)" stroke="#a78bfa" strokeWidth="1.5"/>
          <text x="380" y="433" textAnchor="middle" fill="#a78bfa" fontSize="11" fontWeight="bold">Shared PostgreSQL (partner_b4t)</text>
          <text x="380" y="450" textAnchor="middle" fill="#6b7280" fontSize="9">Shared data layer — Agent records, bookings, leads, commissions</text>

          <rect x="40" y="510" width="200" height="70" rx="6" fill="#ffffff"/>
          <rect x="40" y="510" width="200" height="70" rx="6" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1.5"/>
          <text x="140" y="540" textAnchor="middle" fill="#004d2c" fontSize="12" fontWeight="bold">Admin Dashboard</text>
          <text x="140" y="557" textAnchor="middle" fill="#6b7280" fontSize="9">React 18 / MUI / Redux</text>
          <text x="140" y="572" textAnchor="middle" fill="#6b7280" fontSize="9">Internal Operations</text>

          <path d="M 240 545 L 260 545 L 260 252" fill="none" stroke="#004d2c" strokeWidth="1.5" markerEnd="url(#arrow-cyan)"/>

          <path d="M 380 465 L 380 480" fill="none" stroke="#a78bfa" strokeWidth="1.5" markerEnd="url(#arrow-violet)"/>

          <path d="M 500 252 L 520 252 L 520 170 L 680 170 L 680 210" fill="none" stroke="#059669" strokeWidth="1.5" strokeDasharray="6,3" markerEnd="url(#arrow-emerald)"/>

          <path d="M 580 437 L 680 437 L 680 295" fill="none" stroke="#a78bfa" strokeWidth="1.5" strokeDasharray="4,3" markerEnd="url(#arrow-violet)"/>

          <rect x="540" y="210" width="280" height="85" rx="6" fill="#ffffff"/>
          <rect x="540" y="210" width="280" height="85" rx="6" fill="rgba(0,77,44,0.06)" stroke="#059669" strokeWidth="1.5"/>
          <text x="680" y="240" textAnchor="middle" fill="#059669" fontSize="12" fontWeight="bold">Agent Portal API (Laravel)</text>
          <text x="680" y="257" textAnchor="middle" fill="#6b7280" fontSize="9">partner.b4t.com / Laravel 12 + MySQL</text>
          <text x="680" y="272" textAnchor="middle" fill="#6b7280" fontSize="9">Agent Auth · Leads · Rewards · KYC</text>
          <text x="680" y="287" textAnchor="middle" fill="#6b7280" fontSize="9">Matchboard · Wallet · Documents</text>

          <path d="M 680 295 L 680 335" fill="none" stroke="#a78bfa" strokeWidth="1.5" markerEnd="url(#arrow-violet)"/>

          <rect x="625" y="335" width="110" height="55" rx="6" fill="#ffffff"/>
          <rect x="625" y="335" width="110" height="55" rx="6" fill="rgba(76, 29, 149, 0.06)" stroke="#a78bfa" strokeWidth="1.5"/>
          <text x="680" y="358" textAnchor="middle" fill="#a78bfa" fontSize="11" fontWeight="bold">MySQL</text>
          <text x="680" y="375" textAnchor="middle" fill="#6b7280" fontSize="9">Agent Profiles ·</text>
          <text x="680" y="385" textAnchor="middle" fill="#6b7280" fontSize="9">Leads · Rewards</text>

          <rect x="810" y="335" width="110" height="55" rx="6" fill="#ffffff"/>
          <rect x="810" y="335" width="110" height="55" rx="6" fill="rgba(30, 41, 59, 0.05)" stroke="#6b7280" strokeWidth="1.5"/>
          <text x="865" y="358" textAnchor="middle" fill="#6b7280" fontSize="11" fontWeight="bold">Redis</text>
          <text x="865" y="375" textAnchor="middle" fill="#6b7280" fontSize="9">Cache · Queue</text>
          <text x="865" y="385" textAnchor="middle" fill="#6b7280" fontSize="9">(Horizon)</text>

          <path d="M 780 252 L 865 252 L 865 335" fill="none" stroke="#6b7280" strokeWidth="1" strokeDasharray="3,2"/>

          <rect x="540" y="55" width="280" height="70" rx="6" fill="#ffffff"/>
          <rect x="540" y="55" width="280" height="70" rx="6" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1.5"/>
          <text x="680" y="85" textAnchor="middle" fill="#004d2c" fontSize="12" fontWeight="bold">Agent Mobile App</text>
          <text x="680" y="102" textAnchor="middle" fill="#6b7280" fontSize="9">Flutter / Riverpod</text>
          <text x="680" y="115" textAnchor="middle" fill="#6b7280" fontSize="9">Partner / Business Agents</text>

          <path d="M 680 125 L 680 210" fill="none" stroke="#004d2c" strokeWidth="1.5" markerEnd="url(#arrow-cyan)"/>

          <rect x="40" y="620" width="940" height="90" rx="12" fill="none" stroke="#6b7280" strokeWidth="1" strokeDasharray="4,4" opacity="0.5"/>
          <text x="510" y="640" textAnchor="middle" fill="#6b7280" fontSize="10" opacity="0.7">External Services</text>

          <rect x="60" y="650" width="130" height="50" rx="6" fill="#ffffff"/>
          <rect x="60" y="650" width="130" height="50" rx="6" fill="rgba(120, 53, 15, 0.06)" stroke="#f59e0b" strokeWidth="1.5"/>
          <text x="125" y="672" textAnchor="middle" fill="#f59e0b" fontSize="11" fontWeight="bold">Stripe</text>
          <text x="125" y="688" textAnchor="middle" fill="#6b7280" fontSize="9">Payments / Refunds</text>

          <rect x="220" y="650" width="130" height="50" rx="6" fill="#ffffff"/>
          <rect x="220" y="650" width="130" height="50" rx="6" fill="rgba(136, 19, 55, 0.06)" stroke="#f43f5e" strokeWidth="1.5"/>
          <text x="285" y="672" textAnchor="middle" fill="#f43f5e" fontSize="11" fontWeight="bold">Shufti Pro</text>
          <text x="285" y="688" textAnchor="middle" fill="#6b7280" fontSize="9">KYC Verification</text>

          <rect x="380" y="650" width="130" height="50" rx="6" fill="#ffffff"/>
          <rect x="380" y="650" width="130" height="50" rx="6" fill="rgba(120, 53, 15, 0.06)" stroke="#f59e0b" strokeWidth="1.5"/>
          <text x="445" y="672" textAnchor="middle" fill="#f59e0b" fontSize="11" fontWeight="bold">Firebase FCM</text>
          <text x="445" y="688" textAnchor="middle" fill="#6b7280" fontSize="9">Push Notifications</text>

          <rect x="540" y="650" width="130" height="50" rx="6" fill="#ffffff"/>
          <rect x="540" y="650" width="130" height="50" rx="6" fill="rgba(120, 53, 15, 0.06)" stroke="#f59e0b" strokeWidth="1.5"/>
          <text x="605" y="672" textAnchor="middle" fill="#f59e0b" fontSize="11" fontWeight="bold">FlightAware</text>
          <text x="605" y="688" textAnchor="middle" fill="#6b7280" fontSize="9">Flight Data API</text>

          <rect x="700" y="650" width="130" height="50" rx="6" fill="#ffffff"/>
          <rect x="700" y="650" width="130" height="50" rx="6" fill="rgba(120, 53, 15, 0.06)" stroke="#f59e0b" strokeWidth="1.5"/>
          <text x="765" y="672" textAnchor="middle" fill="#f59e0b" fontSize="11" fontWeight="bold">Mailtrap / SendGrid</text>
          <text x="765" y="688" textAnchor="middle" fill="#6b7280" fontSize="9">Transactional Email</text>

          <rect x="860" y="650" width="100" height="50" rx="6" fill="#ffffff"/>
          <rect x="860" y="650" width="100" height="50" rx="6" fill="rgba(120, 53, 15, 0.06)" stroke="#f59e0b" strokeWidth="1.5"/>
          <text x="910" y="672" textAnchor="middle" fill="#f59e0b" fontSize="11" fontWeight="bold">AWS S3</text>
          <text x="910" y="688" textAnchor="middle" fill="#6b7280" fontSize="9">Document Storage</text>

          <path d="M 380 287 L 125 287 L 125 650" fill="none" stroke="#f59e0b" strokeWidth="1" strokeDasharray="3,2" markerEnd="url(#arrow)"/>
          <path d="M 380 287 L 285 287 L 285 650" fill="none" stroke="#f43f5e" strokeWidth="1" strokeDasharray="3,2" markerEnd="url(#arrow-dashed)"/>
          <path d="M 380 287 L 445 287 L 445 650" fill="none" stroke="#f59e0b" strokeWidth="1" strokeDasharray="3,2" markerEnd="url(#arrow)"/>
          <path d="M 380 287 L 605 287 L 605 650" fill="none" stroke="#f59e0b" strokeWidth="1" strokeDasharray="3,2" markerEnd="url(#arrow)"/>
          <path d="M 380 287 L 765 287 L 765 650" fill="none" stroke="#f59e0b" strokeWidth="1" strokeDasharray="3,2" markerEnd="url(#arrow)"/>
          <path d="M 380 287 L 910 287 L 910 650" fill="none" stroke="#f59e0b" strokeWidth="1" strokeDasharray="3,2" markerEnd="url(#arrow)"/>

          <rect x="40" y="740" width="940" height="100" rx="8" fill="#ffffff" stroke="#e5e7eb" strokeWidth="1"/>
          <text x="60" y="760" fill="#6b7280" fontSize="10">Legend</text>
          <rect x="60" y="770" width="18" height="10" rx="2" fill="rgba(0,77,44,0.04)" stroke="#004d2c" strokeWidth="1"/>
          <text x="85" y="780" fill="#4b5563" fontSize="9">Frontend (Consumer Layer)</text>
          <rect x="280" y="770" width="18" height="10" rx="2" fill="rgba(0,77,44,0.06)" stroke="#059669" strokeWidth="1"/>
          <text x="305" y="780" fill="#4b5563" fontSize="9">Backend API Services</text>
          <rect x="500" y="770" width="18" height="10" rx="2" fill="rgba(76, 29, 149, 0.06)" stroke="#a78bfa" strokeWidth="1"/>
          <text x="525" y="780" fill="#4b5563" fontSize="9">Data Stores</text>
          <rect x="680" y="770" width="18" height="10" rx="2" fill="rgba(120, 53, 15, 0.06)" stroke="#f59e0b" strokeWidth="1"/>
          <text x="705" y="780" fill="#4b5563" fontSize="9">External / 3rd Party</text>

          <rect x="60" y="795" width="18" height="10" rx="2" fill="rgba(136, 19, 55, 0.06)" stroke="#f43f5e" strokeWidth="1"/>
          <text x="85" y="805" fill="#4b5563" fontSize="9">Security / Verification</text>
          <rect x="280" y="795" width="18" height="10" rx="2" fill="rgba(30, 41, 59, 0.05)" stroke="#6b7280" strokeWidth="1"/>
          <text x="305" y="805" fill="#4b5563" fontSize="9">Infrastructure (Redis)</text>
          <line x1="500" y1="800" x2="520" y2="800" stroke="#059669" strokeWidth="1.5" markerEnd="url(#arrow)"/>
          <text x="530" y="805" fill="#4b5563" fontSize="9">Data flow / API call</text>
          <line x1="680" y1="800" x2="700" y2="800" stroke="#a78bfa" strokeWidth="1.5" strokeDasharray="4,3"/>
          <text x="710" y="805" fill="#4b5563" fontSize="9">Shared DB access</text>
        </svg>
      </div>

      <div className="grid-cards">
        <div className="card">
          <div className="card-header"><div className="card-dot cyan"></div><h3>Consumer App (React Native)</h3></div>
          <ul>
            <li><strong>Care Seekers</strong> search for travel assistance</li>
            <li>Book Carers for their flight journey</li>
            <li>Live journey tracking via OTP & GPS</li>
            <li>Family member management</li>
            <li>In-app chat with carers</li>
          </ul>
        </div>
        <div className="card">
          <div className="card-header"><div className="card-dot emerald"></div><h3>Agent App (Flutter)</h3></div>
          <ul>
            <li><strong>Care Providers / Agents</strong> offer assistance</li>
            <li>Lead submission & conversion tracking</li>
            <li>Live matchboard with route map</li>
            <li>Rewards, wallet & withdrawal</li>
            <li>KYC verification (Shufti Pro)</li>
          </ul>
        </div>
        <div className="card">
          <div className="card-header"><div className="card-dot violet"></div><h3>Admin Dashboard (React)</h3></div>
          <ul>
            <li><strong>Internal operations</strong> management</li>
            <li>User & booking management</li>
            <li>Commission & pricing configuration</li>
            <li>Content management (medical issues, docs, professions)</li>
            <li>Promotions, notifications & reports</li>
          </ul>
        </div>
      </div>

      <ExpandableCard onClick={() => toggleCard(0)}>
        <div className="card-header clickable">
          <span className="card-dot cyan"></span><h3>Architecture Components</h3>
        </div>
        <div className={`card-body ${openCards[0] ? 'open' : 'collapsed'}`}>
          <table>
            <thead>
              <tr><th>Component</th><th>Technology</th><th>Description</th></tr>
            </thead>
            <tbody>
              <tr><td>Consumer Mobile</td><td>React Native</td><td>Care Seeker mobile app</td></tr>
              <tr><td>Public Website</td><td>Laravel/Vue</td><td>Marketing + lead gen proxy</td></tr>
              <tr><td>Consumer API</td><td>Node.js/MongoDB</td><td>Core backend</td></tr>
              <tr><td>Admin Dashboard</td><td>React/MUI</td><td>Internal operations panel</td></tr>
              <tr><td>Agent Portal API</td><td>Laravel/MySQL</td><td>Partner management</td></tr>
              <tr><td>Agent Mobile</td><td>Flutter/Riverpod</td><td>Carer/partner mobile</td></tr>
              <tr><td>External Services</td><td>Stripe/Shufti/Firebase/Flights/Email/S3</td><td>3rd party integrations</td></tr>
            </tbody>
          </table>
        </div>
      </ExpandableCard>

      <ExpandableCard onClick={() => toggleCard(1)}>
        <div className="card-header clickable">
          <span className="card-dot emerald"></span><h3>Communication Patterns</h3>
        </div>
        <div className={`card-body ${openCards[1] ? 'open' : 'collapsed'}`}>
          <table>
            <thead>
              <tr><th>Pattern</th><th>Mechanism</th><th>Details</th></tr>
            </thead>
            <tbody>
              <tr><td>Proxy Pattern</td><td>Website → API via <code>VITE_API_BEARER_TOKEN</code></td><td>Public website acts as proxy to Consumer API</td></tr>
              <tr><td>Cross-API Token</td><td>Business API → Consumer API via <code>MATCHBOARD_TOKEN</code> + <code>VERIFICATION_TOKEN</code></td><td>Authenticated cross-service communication</td></tr>
              <tr><td>Shared Database</td><td>Consumer + Business APIs share PostgreSQL <code>partner_b4t</code></td><td>Direct database-level data sharing</td></tr>
              <tr><td>Socket.IO</td><td>Real-time chat via WebSocket rooms per booking</td><td>Live messaging between care seekers and carers</td></tr>
            </tbody>
          </table>
        </div>
      </ExpandableCard>

      <ExpandableCard onClick={() => toggleCard(2)}>
        <div className="card-header clickable">
          <span className="card-dot violet"></span><h3>Environments & URLs</h3>
        </div>
        <div className={`card-body ${openCards[2] ? 'open' : 'collapsed'}`}>
          <table>
            <thead>
              <tr><th>Service</th><th>Development</th><th>Production</th></tr>
            </thead>
            <tbody>
              <tr><td>Consumer API</td><td>localhost:8000</td><td>api.b4t.com</td></tr>
              <tr><td>Admin Dashboard</td><td>localhost:3000</td><td>internal</td></tr>
              <tr><td>Agent Portal</td><td>localhost:8001</td><td>partner.b4t.com</td></tr>
              <tr><td>Consumer Mobile</td><td>Metro :8081</td><td>App Store</td></tr>
              <tr><td>Agent Mobile</td><td>flutter run</td><td>App Store</td></tr>
              <tr><td>Website</td><td>Vite :5173</td><td>b4t.com</td></tr>
            </tbody>
          </table>
        </div>
      </ExpandableCard>
    </DocWrapper>
  );
}
